import { RESET, useUpdateAtom } from 'jotai/utils';
import { proxyConfigAtom, proxyDataAtom, proxyStateAtom } from '../state';
export default function useResetState() {
  var updateConfigAtom = useUpdateAtom(proxyConfigAtom);
  var updateDataAtom = useUpdateAtom(proxyDataAtom);
  var updateStateAtom = useUpdateAtom(proxyStateAtom);
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$all = options.all,
      all = _options$all === void 0 ? false : _options$all,
      _options$resetBillId = options.resetBillId,
      resetBillId = _options$resetBillId === void 0 ? true : _options$resetBillId;
    if (all) {
      updateConfigAtom(RESET);
      updateDataAtom(RESET);
      updateStateAtom(RESET);
      return;
    }
    if (resetBillId) {
      // 重置billId
      updateConfigAtom(function (draft) {
        draft.billId = '';
      });
    }
    updateStateAtom(function (draft) {
      draft.payLoading = false;
      draft.cancelLoading = false;
    });
  };
}